import React, { useState } from 'react';
import { IconInfoCircle, IconX } from '@tabler/icons-react';

const MessageForm = () => {
  const [email, setEmail] = useState('');
  const [user, setUser] = useState('');
  const [message, setMessage] = useState('');
  const [showInfo, setShowInfo] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const supportEmail = "soporte-rolplay@audioweb.com.mx"; // Dirección de correo de soporte
    const subject = `Support Request from ${user}`;
    const body = `User: ${user} Email: ${email} Message: ${message}`;
    
    // Construimos el enlace mailto con los datos del formulario
    window.location.href = `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="flex justify-center items-center h-screen w-full">
      <div className="w-full max-w-md">
        {/* Alert informativo */}
        <div className="mb-6">
          <div className="p-4 border border-red-200 bg-red-50 rounded-xl text-red-800 text-sm flex items-center gap-2">
            <IconInfoCircle className="text-red-600 flex-shrink-0" size={20} />
            <p>
              Este formulario está diseñado para reportar errores críticos directamente al equipo de Rolplay.
              Correo de soporte: <span className="font-semibold">soporte-rolplay@audioweb.com.mx</span>
            </p>
          </div>
        </div>

        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-gray-900">Support Message</h2>
          <button
            onClick={() => setShowInfo(true)}
            className="relative group"
          >
            <div className="absolute -inset-3 bg-red-500/50 rounded-full blur opacity-75 group-hover:opacity-100 animate-pulse"></div>
            <div className="relative w-8 h-8 bg-red-700 rounded-full text-white hover:bg-red-800 transition-colors duration-200 flex items-center justify-center">
              <IconInfoCircle size={18} strokeWidth={2.5} />
            </div>
          </button>
        </div>

        {/* Modal informativo */}
        {showInfo && (
          <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-50 p-4 backdrop-blur-sm">
            <div className="bg-white rounded-2xl w-11/12 max-w-2xl relative p-6 shadow-2xl">
              <button 
                onClick={() => setShowInfo(false)}
                className="absolute -top-3 -right-3 w-8 h-8 bg-red-700 text-white rounded-full flex items-center justify-center hover:bg-red-800 transition-colors duration-200"
              >
                <IconX size={20} />
              </button>
              
              <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                <IconInfoCircle size={24} className="text-red-700" />
                Información del Formulario de Soporte
              </h2>
              
              <div className="space-y-4 text-gray-600">
                <p className="leading-relaxed">
                  Este formulario está diseñado para reportar problemas críticos que requieren atención inmediata del equipo de Rolplay.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-800 mb-2">¿Cuándo usar este formulario?</h3>
                  <ul className="list-disc list-inside space-y-1 text-sm">
                    <li>Errores críticos que impiden el uso del simulador</li>
                    <li>Problemas de acceso generalizados</li>
                    <li>Fallos en la funcionalidad principal</li>
                    <li>Casos que requieren atención urgente</li>
                  </ul>
                </div>
                <p className="text-sm bg-red-50 p-3 rounded-lg border border-red-100">
                  Correo de soporte: <span className="font-semibold">soporte-rolplay@audioweb.com.mx</span>
                </p>
              </div>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit} className="bg-white p-10 rounded-2xl shadow-lg border border-red-100">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
            Support Message
          </h2>
          
          <div className="flex flex-col">
            <label className="text-gray-800 text-base mb-1">Email:</label>
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
              className="border border-red-700 rounded-2xl p-3 bg-gray-50 text-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-red-700 focus:border-transparent"
            />
          </div>

          <div className="flex flex-col">
            <label className="text-gray-800 text-base mb-1">Username:</label>
            <input 
              type="text" 
              value={user} 
              onChange={(e) => setUser(e.target.value)} 
              required 
              className="border border-red-700 rounded-2xl p-3 bg-gray-50 text-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-red-700 focus:border-transparent"
            />
          </div>

          <div className="flex flex-col">
            <label className="text-gray-800 text-base mb-1">Message:</label>
            <textarea 
              value={message} 
              onChange={(e) => setMessage(e.target.value)} 
              required 
              className="border border-red-700 rounded-2xl p-3 bg-gray-50 text-gray-800 text-sm h-[100px] resize-none focus:outline-none focus:ring-2 focus:ring-red-700 focus:border-transparent"
            />
          </div>

          <button 
            type="submit" 
            className="bg-red-700 text-white py-3 px-4 rounded-2xl text-base hover:bg-red-800 transition-colors duration-300 mt-4"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default MessageForm;